module.exports = __webpack_public_path__ + "img/modelIcon_qj.0e44b85f.png";